// Mock data for ADMIN Hausverwaltung

export const companyData = {
  name: "ADMIN Hausverwaltung",
  tagline: "Ihre zuverlässige Hausverwaltung in Magdeburg und Umgebung",
  subtitle: "Über 20 Jahre Erfahrung in Immobilienverwaltung, Vermietung und Hausmeisterservice – persönlich, zuverlässig und transparent.",
  owner: "Bärbel Paul",
  address: {
    street: "Domblick 24 c",
    zip: "39175",
    city: "Gerwisch"
  },
  contact: {
    phone: "0171 7431533",
    email: "baerbel.paul@admin-hausverwaltung.de",
    website: "www.admin-hausverwaltung.de"
  },
  taxInfo: {
    steuerNr: "103/255/01524",
    idNr: "98520438175",
    finanzbehoerde: "Genthin"
  },
  gewerbeerlaubnis: "nach § 34c GewO der Landeshauptstadt Magdeburg, Bei der Hauptwache 4, 39104 Magdeburg",
  region: "Magdeburg, Gerwisch und nähere Umgebung",
  experience: "25 Jahre"
};

export const aboutText = `ADMIN Hausverwaltung steht seit über 20 Jahren für zuverlässige Verwaltungsarbeit in Magdeburg und der Region. Wir verbinden fachliche Kompetenz mit persönlicher Betreuung und sind für unsere Eigentümer, Mieter und Partner jederzeit ansprechbar. Durch regelmäßige Fortbildungen bleiben wir bei allen rechtlichen und technischen Themen auf dem aktuellen Stand und bieten eine sachliche, unparteiische Verwaltung Ihrer Immobilien.`;

export const services = [
  {
    id: 1,
    title: "Immobilienverwaltung",
    description: "WEG-Verwaltung, Verwaltung von Sondereigentum, Mietverwaltung.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Vermietung",
    description: "Unterstützung bei Neuvermietung, Mietvertragsabwicklung, Übergabe/Abnahme.",
    icon: "Key"
  },
  {
    id: 3,
    title: "Immobilienverkauf",
    description: "Begleitung beim Verkauf, Vorbereitung von Unterlagen, Koordination von Terminen.",
    icon: "HandCoins"
  },
  {
    id: 4,
    title: "Hausmeisterservice",
    description: "Organisation von Hausmeisterei, Reinigung, Winterdienst, Grünanlagenpflege.",
    icon: "Wrench"
  }
];

export const usps = [
  {
    id: 1,
    title: "Über 20 Jahre Erfahrung",
    description: "im Immobilienbereich"
  },
  {
    id: 2,
    title: "Persönliche Betreuung",
    description: "durch ein kleines, eingespieltes Team"
  },
  {
    id: 3,
    title: "Transparente Abrechnungen",
    description: "und zuverlässige Kommunikation"
  },
  {
    id: 4,
    title: "Regionale Verankerung",
    description: "in Magdeburg und Umgebung"
  }
];

export const anniversaryText = "Unsere Hausverwaltung feiert dieses Jahr 25-jähriges Bestehen – vielen Dank für das Vertrauen unserer Eigentümer, Mieter und Partner.";

export const referenceNote = "Referenzen und Verwaltungsobjekte nennen wir Ihnen gerne im persönlichen Gespräch.";

export const navLinks = [
  { id: "home", label: "Start", href: "#home" },
  { id: "about", label: "Über uns", href: "#about" },
  { id: "services", label: "Leistungen", href: "#services" },
  { id: "objekte", label: "Objekte", href: "#objekte" },
  { id: "contact", label: "Kontakt", href: "#contact" }
];

// Company images
export const companyImages = {
  office1: "https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/olamdt4g_Anni%20B%C3%BCro%202.jpg",
  meetingRoom: "https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/eonan627_Anni.JPG",
  office2: "https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/l47xdmhq_Kahnstra%C3%9Fe%201%20B%C3%BCro%202.JPG",
  office3: "https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/ygpawuwn_Kahnstra%C3%9Fe%201%20B%C3%BCro.JPG"
};

// Verwaltungsobjekte (Beispieldaten)
export const objekte = [
  {
    id: 1,
    name: "Mehrfamilienhaus Magdeburg-Stadtfeld",
    objektart: "WEG-Verwaltung",
    einheiten: 12,
    baujahr: 1998,
    beschreibung: "Gepflegtes Mehrfamilienhaus in ruhiger Wohnlage mit Tiefgarage und Gemeinschaftsgarten.",
    bild: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&q=80"
  },
  {
    id: 2,
    name: "Wohnanlage Gerwisch-Mitte",
    objektart: "WEG-Verwaltung",
    einheiten: 24,
    baujahr: 2005,
    beschreibung: "Moderne Wohnanlage mit Aufzug, Balkonen und großzügigen Grünflächen.",
    bild: "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=600&q=80"
  },
  {
    id: 3,
    name: "Altbau-Ensemble Magdeburg-Buckau",
    objektart: "Mietverwaltung",
    einheiten: 18,
    baujahr: 1925,
    beschreibung: "Denkmalgeschütztes Altbau-Ensemble mit liebevoll sanierten Wohnungen und hohen Decken.",
    bild: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80"
  },
  {
    id: 4,
    name: "Neubau-Projekt Herrenkrug",
    objektart: "WEG-Verwaltung",
    einheiten: 32,
    baujahr: 2020,
    beschreibung: "Exklusive Neubau-Wohnanlage mit energieeffizienter Bauweise und Smart-Home-Ausstattung.",
    bild: "https://images.unsplash.com/photo-1567684014761-b65e2e59b9eb?w=600&q=80"
  },
  {
    id: 5,
    name: "Mehrfamilienhaus Biederitz",
    objektart: "Mietverwaltung",
    einheiten: 8,
    baujahr: 1992,
    beschreibung: "Familienfreundliches Wohnhaus mit großem Garten und Spielplatz in ruhiger Lage.",
    bild: "https://images.unsplash.com/photo-1449844908441-8829872d2607?w=600&q=80"
  },
  {
    id: 6,
    name: "Stadtresidenz Magdeburg-Zentrum",
    objektart: "WEG-Verwaltung",
    einheiten: 45,
    baujahr: 2015,
    beschreibung: "Zentral gelegene Wohnanlage mit Concierge-Service und Tiefgarage.",
    bild: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&q=80"
  },
  {
    id: 7,
    name: "Wohnpark Am Elbufer",
    objektart: "WEG-Verwaltung",
    einheiten: 28,
    baujahr: 2018,
    beschreibung: "Attraktive Wohnlage direkt an der Elbe mit Blick auf den Stadtpark.",
    bild: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600&q=80"
  },
  {
    id: 8,
    name: "Gewerbe- und Wohnhaus Sudenburg",
    objektart: "Mietverwaltung",
    einheiten: 14,
    baujahr: 2001,
    beschreibung: "Gemischt genutztes Objekt mit Gewerbeeinheiten im Erdgeschoss und Wohnungen in den Obergeschossen.",
    bild: "https://images.unsplash.com/photo-1464082354059-27db6ce50048?w=600&q=80"
  }
];
